import { Stack } from "@mui/material";
import FileIcon from "@entrilia/shared/components/FileIcon";
import TypographyTooltipEllipsis from "@entrilia/shared/components/TypographyTooltipEllipsis";
import type { AttachedDocument } from "../../../../../../../../../api/types/svTypes";
import { formatFileLabel, normalizeExtension } from "../utils/transactionAttachmentsHelper";

const TransactionAttachedDocumentFileStrip = ({ item }: { item: AttachedDocument }) => (
  <Stack
    direction="row"
    spacing={1}
    sx={{ alignItems: "center", px: 3, py: 1, borderBottom: 1, borderColor: "divider", flexShrink: 0 }}
  >
    <FileIcon fileExtension={normalizeExtension(item.fileExtension)} fontSize="small" />
    <TypographyTooltipEllipsis
      text={formatFileLabel(item)}
      typographyProps={{ variant: "subtitle2" }}
      tooltipProps={{ disableInteractive: true }}
    />
  </Stack>
);

export default TransactionAttachedDocumentFileStrip;
